import { Component, computed, input, InputSignal, Signal } from '@angular/core';
import { AlertComponent } from '../../../../../../../common/alert/alert.component';
import { CopyToClipboardDirective } from '../../../../../../../directives/copy-to-clipboard.directive';
import { RouterLink } from '@angular/router';
import { SessionService } from '../../../../../../../services/ssession.service';
import { ApplicationAppEntityApplicationRead } from '../../../../../../../openapi';

@Component({
  selector: 'app-attachments-data-alerts',
  standalone: true,
  imports: [
    AlertComponent,
    CopyToClipboardDirective,
    RouterLink
  ],
  templateUrl: './attachments-data-alerts.component.html'
})
export class AttachmentsDataAlertsComponent {

  public application: InputSignal<ApplicationAppEntityApplicationRead | null> = input<ApplicationAppEntityApplicationRead | null>(null);

  public token: string | null = SessionService.GetAccessToken();

  public feeCategory: InputSignal<string | null> = input<string | null>(null);

  public contentUrl: Signal<string | null> = computed(() => this.application()?.service?.url?.replace('/', '') || null)

  public isFiledByProxy: Signal<boolean> = computed(() => !!this.application()?.isFiledByProxy)

}
